export default function ($translateProvider) {
	'ngInject';

	$translateProvider
		.translations('bg', {
			'PAYMENT': {
				'LABEL': 'Автобуси под наем',
				'PARAGRAPH_ONE': 'Фирма Груп ООД и Моди Транс ООД предлага луксозни автобуси под наем от марките Mercedes-Benz и Bova',
				'PARAGRAPH_TWO': 'В зависимост от Вашите нужди можем да се договорим за цена на километър или на ден, като плащането става в брой или по банков път.',
				'PARAGRAPH_THREE': 'Можем да Ви предоставим под наем автобус, не по-рано от 48 часа след сключване на сделката.',
				'PARAGRAPH_FOUR': 'Ако имате интерес моля обадете ни се на ',
				'PARAGRAPH_FIVE': 'Благодарим Ви!',
				'CONTACT_PHONES': 'GSM 0878 215 150 или тел. 981 4213'
			}
		})
		.translations('en', {
			'PAYMENT': {
				'LABEL': 'Rent a bus',
				'PARAGRAPH_ONE': 'Companies "Group" Ltd. and "Modi Trans" Ltd offers luxury bus rental from the brands Mercedes-Benz and Bova',
				'PARAGRAPH_TWO': 'Depending on your needs we can negotiate a price per kilometer or per day, the payment is in cash or by bank transfer.',
				'PARAGRAPH_THREE': 'We can provide you with a bus not earlier than 48 hours after the conclusion of the transaction. ',
				'PARAGRAPH_FOUR': 'If you are interested please call us at',
				'PARAGRAPH_FIVE': 'Thank you!',
				'CONTACT_PHONES': 'Mobile: 0878 215 150, Phone: 981 4213'
			}
		})
		.translations('cz', {
			'PAYMENT': {
				'LABEL': 'Pronájem autobusů',
				'PARAGRAPH_ONE': 'Firma GROUP s.r.o a Modi Trans s.r.o. nabízí luxusní autobusy do pronájmu Značky Mercedes-Benz a Bova',
				'PARAGRAPH_TWO': ' Podle Vašich potřeb můžeme domluvit cenu na kilometr nebo na den, přičemž platby jsou v hotovosti nebo bankovním převodem.',
				'PARAGRAPH_THREE': 'Autobus Vám m§žeme pronajmout, nejdříve 48 hodin po uzavření smlouvy.',
				'PARAGRAPH_FOUR': 'Máte-li zájem, prosím ozvěte se na ',
				'PARAGRAPH_FIVE': 'Děkujeme Vám!',
				'CONTACT_PHONES': 'GSM 0878 215 150 nebo na tel. 981 4213'
			}
		})
		.translations('hu', {
			'PAYMENT': {
				'LABEL': 'Autóbusz bérlése',
				'PARAGRAPH_ONE': 'A GROUP" Kft. és a Modi Trans Kft Mercedes-Benz és Bova luxus autóbuszokat kínál bérlésre.',
				'PARAGRAPH_TWO': 'Az igényeitől függően tudunk tárgyalni az ár kilométerenként vagy naponta , a fizetés készpénzzel , vagy banki átutalással.',
				'PARAGRAPH_THREE': 'A pénzügyi rendezés készpénzben történik. Az autóbuszt legkorábban 48 órával a megrendelést követően tudjuk biztosítani. ',
				'PARAGRAPH_FOUR': 'Az alábbi elérhetőségeken várjuk szíves érdeklődését: mobil ',
				'PARAGRAPH_FIVE': 'Köszönjük szépen',
				'CONTACT_PHONES': '(0878) 215 150, telefon: 981 4213'
			}
		});
}



/** WEBPACK FOOTER **
 ** ./client/public/main/rent/rent.locale.js
 **/